import { ScrollAnimationWithEase } from '@studiometa/ui';

/**
 * @extends ScrollAnimationWithEase
 */
export default class ScrollAnimation extends ScrollAnimationWithEase {
  /**
   * Get the target element for the animation.
   */
  get target(): HTMLElement {
    const target = this.$refs.target || this.$el;
    return Array.isArray(target) ? target[0] : target;
  }
}
